<div
  id="navigationPanel"
  class="hidden xl:block w-screen xl:w-auto h-screen fixed z-1"
>
  <div
    class="navigation-overlay xl:hidden w-full h-full absolute cursor-pointer bg-black-alpha-50"
    pStyleClass="#navigationPanel"
    leaveToClass="hidden"
    leaveActiveClass="fadeoutleft"
    toggleClass="hidden"
  ></div>

  <div
    id="navigation"
    class="w-18rem h-screen select-none surface-ground border-right-1 xl:border-right-none surface-border overflow-hidden"
  >
    <div class="flex flex-column h-full">
      <div
        class="flex align-items-center px-5 flex-shrink-0 text-3xl font-bold"
        style="height: 60px; width: 240px;"
      >
        <img
          [src]="'assets/images/logo.png'"
          class="mr-3 border-circle"
          style="width: 32px; height: 32px"
        />
        <span class="font-semibold"> S2 Emulator </span>
      </div>
      <div class="overflow-y-auto">
        <ul class="list-none p-3 m-0 overflow-hidden">
          <ng-container
            *ngFor="let item of navigationItems()"
            [ngTemplateOutlet]="
              item.items
                ? item.expandable
                  ? expandableListItem
                  : staticListItem
                : listItem
            "
            [ngTemplateOutletContext]="{ $implicit: item }"
          >
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div>

<ng-template #listItem let-item>
  <li *ngIf="item.visible">
    <a
      pRipple
      class="p-element no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-200 transition-duration-150 transition-colors"
      [routerLink]="item.routerLink"
      routerLinkActive="text-blue-500"
    >
      <i class="mr-2" [ngClass]="item.icon"></i>
      <span class="font-semibold">{{ item.label }}</span>
    </a>
  </li>
</ng-template>

<ng-template #staticListItem let-item>
  <li *ngIf="item.visible">
    <div
      *ngIf="item.label"
      class="h-2rem py-2 px-2 flex align-items-center font-bold text-sm text-500 uppercase"
    >
      {{ item.label }}
    </div>
    <ul class="list-none p-0 m-0 overflow-y-hidden">
      <ng-container
        *ngFor="let item of item.items"
        [ngTemplateOutlet]="
          item.items
            ? item.expandable
              ? expandableListItem
              : staticListItem
            : listItem
        "
        [ngTemplateOutletContext]="{ $implicit: item }"
      >
      </ng-container>
    </ul>
  </li>
</ng-template>

<ng-template #expandableListItem let-item>
  <li *ngIf="item.visible">
    <a
      pRipple
      class="p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-200 transition-duration-150 transition-colors"
      [ngClass]="item.styleClass"
      (click)="toggleItem(item)"
    >
      <i class="mr-2" [ngClass]="item.icon"></i>
      <span class="font-semibold">{{ item.label }}</span>
      <i
        class="pi pi-chevron-down ml-auto transition-all transition-duration-200 transition-ease-in-out"
        [ngClass]="{ '-rotate-180': item.expanded }"
      ></i>
    </a>
    <ul
      [@expandList]="item.expanded ? 'visible' : 'hidden'"
      class="list-none py-0 pl-3 pr-0 m-0 overflow-y-hidden"
    >
      <ng-container
        *ngFor="let item of item.items"
        [ngTemplateOutlet]="
          item.items
            ? item.expandable
              ? expandableListItem
              : staticListItem
            : listItem
        "
        [ngTemplateOutletContext]="{ $implicit: item }"
      >
      </ng-container>
    </ul>
  </li>
</ng-template>
